import React, { useEffect, useMemo, useState } from "react";
import {
  Col,
  Container,
  Row,
  Tab,
  Nav,
  Button,
  Spinner,
  Accordion,
} from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import {
  useCancelOrderMutation,
  useChangeGroupedOrderStatusMutation,
  useChangeMealStatusMutation,
  useGetGroupedOrderInfoQuery,
  useGetGroupedSingleOrderInfoQuery,
  useGetOrderDetailsQuery,
  useGetOrderNewQuery,
  useUpdateOrderMutation,
} from "../../../../store/services/orderService";
import moment from "moment";
import toast from "react-hot-toast";
import styles from "./orderDetail.module.scss";
import {
  macrosBarDynamicPercentage,
  priceCurrency,
} from "../../../../helpers/common";
import OrderMealDetail from "../../../../components/Modals/OrderMealDetail";
import DatesHeader from "../DatesHeader";
import ConfirmationPop from "../../../../components/Modals/ConfirmationPop";

// Function to format the date array into the desired format
const formatDateArray = (dateArray) => {
  // Use Set to get unique dates
  const uniqueDates = [...new Set(dateArray)];

  return uniqueDates.map((dateStr) => {
    const date = moment(dateStr);
    return {
      day: date.format("dddd"), // Day of the week
      dateLabel: date.format("DD/MM"), // Date in "DD/MM" format
      date: date.toISOString(), // ISO format date
    };
  });
};

const StoreOrderDetailToday = () => {
  const { id } = useParams();
  // const {
  //   data: order,
  //   error,
  //   isLoading,
  // } = useGetOrderDetailsQuery({
  //   pageNo: 1,
  //   limit: 10,
  //   orderBy: "createdAt",
  //   order: -1,
  //   // "status": "confirmed",
  //   // "search": "order123",
  //   orderId: id,
  // });
  const {
    data: order,
    error,
    isLoading,
    refetch,
  } = useGetGroupedSingleOrderInfoQuery({
    pageNo: 1,
    limit: 10,
    orderBy: "createdAt",
    order: 1,
    // "status": "confirmed",
    // "search": "order123",
    groupId: id,
  });

  const [selectedDay, setSelectedDay] = useState(null);
  const [selectedMeal, setSelectedMeal] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [dates, setDates] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedMeals, setSelectedMeals] = useState([]);
  const [selectedMealStatus, setSelectedMealStatus] = useState(null);
  const [updateOrder, { isLoading: isUpdating }] = useCancelOrderMutation();
  const [updateMealStatus, { isLoading: isUpdatingMealStatus }] =
    useChangeMealStatusMutation();
  const [cancelConfirmation, setCancelConfirmation] = useState(false);
  const [
    updateGroupedOrderStatus,
    { isLoading: isUpdatingGroupedOrderStatus },
  ] = useChangeGroupedOrderStatusMutation();
  const [activeButton, setActiveButton] = React.useState(null);

  const [confirmationGroupOrderStatus, setConfirmationGroupOrderStatus] =
    useState(false);
  const [
    confiramtionGroudOrderStatusData,
    setConfirmationGroupOrderStatusData,
  ] = useState(null);

  // Function to handle status update
  // const handleStatusUpdate = async (status) => {
  //   try {
  //     await updateOrder({
  //       userId: id, // Pass the order ID
  //       updatedData: { status }, // Pass the status to update
  //     }).unwrap(); // Await API response
  //     toast.success(`Order status updated to '${status}' successfully`);
  //   } catch (error) {
  //     console.error("Failed to update the order:", error);
  //     toast.error("Failed to update the order. Please try again.");
  //   }
  // };

  const handleStatusUpdate = async () => {
    try {
      const res = await updateOrder({
        orderId: id, // Pass the order ID
        status: "cancelled",
        cancelledAt: new Date(),
      }).unwrap(); // Await API respons
      toast.success(res?.message);
    } catch (error) {
      console.error("Failed to update the order:", error);
      toast.error("Failed to update the order. Please try again.");
    } finally {
      setCancelConfirmation(false);
    }
  };
  useEffect(() => {
    if (selectedDay) {
      const preparingDates = selectedDay?.meals?.map(
        (item) => item.preparingDate
      );
      const dates = formatDateArray(preparingDates);

      setDates(dates);
      if (!selectedDate) {
        setSelectedDate(dates?.[0]?.date); // Set the first date if no date is selected
      } else if (!dates?.some((d) => d.date === selectedDate)) {
        setSelectedDate(dates?.[0]?.date); // Set the first date if selectedDate is not in the list
      } else {
        console.log("in else");
      }
    }
  }, [selectedDay]);
  useEffect(() => {
    if (order?.data?.meals?.length > 0) {
      const firstOrder =
        selectedDay === null
          ? order?.data?.meals[0]
          : order?.data?.meals?.find(
              (it) => it.subOrderID === selectedDay?.subOrderID
            );

      setSelectedDay(firstOrder);
    }
  }, [order]);

  const selectedMealsInfo = useMemo(() => {
    if (!selectedDay || !selectedDate) return [];

    // Filter meals based on the selected dates
    return (
      selectedDay?.meals?.filter((item) =>
        moment(item?.preparingDate).isSame(selectedDate, "day")
      ) || []
    );
  }, [selectedDay, selectedDate]);

  useEffect(() => {
    setSelectedMeals(selectedMealsInfo);
  }, [selectedMealsInfo]);

  console.log("orderDetailData==>>>", order);
  console.log("selectedDay ====>", selectedDay);

  // if (isLoading) {
  //   return <div>Loading...</div>;
  // }

  // if (error) {
  //   return <div>Something went wrong</div>;
  // }

  const [confirmation, setConfirmation] = useState();
  const handleConfirmation = () => setConfirmation(!confirmation);

  const handleChangeStatus = async (status) => {
    try {
      const resp = await updateMealStatus({
        id: selectedMealStatus?._id,
        data: { status: "prepared", preparedAt: new Date() },
      }).unwrap();

      toast.success(resp.message);
      setConfirmation(false);
      
      // Refetch the data to get updated status
      await refetch();
    } catch (error) {
      console.error("Error updating meal status:", error);
      toast.error("Failed to update meal status. Please try again.");
    }
  };

  const handleGroupedOrderStatus = async () => {
    try {
      const { _id, ...rest } = confiramtionGroudOrderStatusData;

      // For meal plans, use updateMealStatus with meal _id (like in order management today)
      // For product-only orders, use updateMealStatus with main order _id
      if (rest?.status === "prepared") {
        if (order?.data?.meals?.length > 0) {
          // Meal plan: use the meal's _id
          const resp = await updateMealStatus({
            data: {
              status: rest.status,
              ...rest,
            },
            id: _id, // Use the meal's _id for meal plans
          }).unwrap();
          toast.success(resp.message);
        } else {
          // Product-only: use main order _id
          const resp = await updateMealStatus({
            data: {
              status: rest.status,
              ...rest,
            },
            id: order?.data?.order?._id,
          }).unwrap();
          toast.success(resp.message);
        }
      } else if (rest?.status === "inTransit") {
        // For inTransit status, use the same approach as prepared
        if (order?.data?.meals?.length > 0) {
          // Meal plan: use the meal's _id
          const resp = await updateMealStatus({
            data: {
              status: rest.status,
              ...rest,
            },
            id: _id, // Use the meal's _id for meal plans
          }).unwrap();
          toast.success(resp.message);
        } else {
          // Product-only: use main order _id
          const resp = await updateMealStatus({
            data: {
              status: rest.status,
              ...rest,
            },
            id: order?.data?.order?._id,
          }).unwrap();
          toast.success(resp.message);
        }
      } else {
        // For other statuses, use grouped order endpoint
        const resp = await updateGroupedOrderStatus({
          id: _id,
          data: {
            ...rest,
          },
        }).unwrap();
        toast.success(resp.message);
      }

      setConfirmationGroupOrderStatus(false);
      setConfirmationGroupOrderStatusData(null);
      
      // Refetch the data to get updated status
      await refetch();
    } catch (error) {
      console.error("Error updating order status:", error);
      toast.error("Failed to update order status. Please try again.");
    }
  };

  const renderButton = (selectedDay) => {
    console.log("Rendering button for status:", selectedDay?.status, "selectedDay:", selectedDay);
    switch (selectedDay?.status) {
      case "confirmed":
        return (
          <Button
            className="d-inline-flex align-items-center justify-content-center commonBtn"
            onClick={() => {
              setConfirmationGroupOrderStatusData({
                status: "inTransit",
                intransitAt: new Date(),
                _id: selectedDay._id,
              });
              setConfirmationGroupOrderStatus(true);
            }}
            disabled={isUpdatingGroupedOrderStatus || isUpdatingMealStatus}
          >
            Mark the order as 'In Transit'
          </Button>
        );
      case "inTransit":
        return (
          <>
            <Button
              className="d-inline-flex align-items-center justify-content-center commonBtn"
              onClick={() => {
                setConfirmationGroupOrderStatusData({
                  status: "delivered",
                  deliveredAt: new Date(),
                  _id: selectedDay._id,
                });
                setConfirmationGroupOrderStatus(true);
              }}
              disabled={isUpdatingGroupedOrderStatus || isUpdatingMealStatus}
            >
              Mark the order as 'Delivered'
            </Button>
            <Button
              className="d-inline-flex align-items-center justify-content-center commonBtn ml-2"
              disabled
            >
              Order is currently 'In Transit'
            </Button>
          </>
        );
      case "delivered":
        return (
          <Button
            className="d-inline-flex align-items-center justify-content-center commonBtn"
            disabled
          >
            Order is already marked as 'Delivered'
          </Button>
        );
      case "paused":
        return (
          <Button
            className="d-inline-flex align-items-center justify-content-center commonBtn"
            disabled
          >
            This order is paused
          </Button>
        );
      case "cancelled":
        return (
          <Button
            className="d-inline-flex align-items-center justify-content-center commonBtn"
            disabled
          >
            This order is cancelled
          </Button>
        );
      case "prepared":
        return (
          <Button
            className="d-inline-flex align-items-center justify-content-center commonBtn"
            onClick={() => {
              setConfirmationGroupOrderStatusData({
                status: "inTransit",
                intransitAt: new Date(),
                _id: selectedDay._id,
              });
              setConfirmationGroupOrderStatus(true);
            }}
            disabled={isUpdatingGroupedOrderStatus || isUpdatingMealStatus}
          >
            Mark the order as 'In Transit'
          </Button>
        );
      default:
        return null;
    }
  };

  return (
    <>
      <ConfirmationPop
        type={"confirmation"}
        confirmation={confirmation}
        setConfirmation={setConfirmation}
        confirmHandler={handleChangeStatus}
      />
      <ConfirmationPop
        type={"confirmation"}
        confirmation={confirmationGroupOrderStatus}
        setConfirmation={setConfirmationGroupOrderStatus}
        confirmHandler={handleGroupedOrderStatus}
      />
      <ConfirmationPop
        type={"confirmation"}
        confirmation={cancelConfirmation}
        setConfirmation={setCancelConfirmation}
        confirmHandler={handleStatusUpdate}
      />
      {modalOpen && (
        <OrderMealDetail
          modalOpen={modalOpen}
          setModalOpen={setModalOpen}
          title={selectedMeal?.name}
          meal={selectedMeal}
        />
      )}
      <section className={`${styles.ordersec} py-5 position-relative`}>
        <Container>
          <Row>
            <Col lg="12">
              <div className="d-flex align-items-center gap-10">
                <Link
                  to="/store-order-management-today"
                  className="border d-flex align-align-align-items-center p-2 rounded"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="12"
                    height="12"
                    viewBox="0 0 10 16"
                    fill="none"
                  >
                    <path
                      d="M8.64707 0.473344C8.55514 0.381188 8.44594 0.308072 8.32572 0.258184C8.20549 0.208296 8.07661 0.182617 7.94644 0.182617C7.81628 0.182617 7.68739 0.208296 7.56717 0.258184C7.44694 0.308072 7.33774 0.381188 7.24582 0.473344L0.667065 7.05209C0.593675 7.12533 0.53545 7.21233 0.495723 7.3081C0.455996 7.40387 0.435547 7.50654 0.435547 7.61022C0.435547 7.7139 0.455996 7.81657 0.495723 7.91234C0.53545 8.00811 0.593675 8.0951 0.667065 8.16834L7.24582 14.7471C7.63373 15.135 8.25915 15.135 8.64707 14.7471C9.03498 14.3592 9.03498 13.7338 8.64707 13.3458L2.9154 7.60626L8.65498 1.86668C9.03498 1.48668 9.03498 0.853344 8.64707 0.473344Z"
                      fill="#1E232C"
                      stroke="#1E232C"
                      stroke-width="0.2"
                    />
                  </svg>
                </Link>
                <h4 className="mb-0 py-3 fw-bold themeBlue text-capitalize">
                  Order Detail
                </h4>
              </div>
            </Col>
            {isLoading && (
              <div className="text-center">
                <div className="spinner-border text-dark" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            )}
          </Row>
          {!isLoading && (
            <Row className="mx-auto" style={{ maxWidth: 1024 }}>
              {order?.data?.order?.status === "paused" &&
                order?.data?.order?.pausedAt && (
                  <Col lg="12">
                    <div className="alert alert-danger" role="alert">
                      This order has been paused from{" "}
                      {moment().diff(
                        moment(order?.data?.order?.pausedAt),
                        "days"
                      )}{" "}
                      {moment().diff(
                        moment(order?.data?.order?.pausedAt),
                        "days"
                      ) === 1
                        ? "day"
                        : "days"}
                      .{/* Please contact the customer. */}
                    </div>
                  </Col>
                )}
              <Col lg="12" className="my-2">
                <div className="mx-auto">
                  <div className="cardCstm bg-light rounded-3 p-2 px-3">
                    <div className="top p-2 d-d-flex align-align-align-items-center justify-content-between border-bottom  d-d-flex-wrap">
                      <h5 className="m-0 fw-sbold">Order List</h5>
                      <p className="m-0 text-muted">
                        {" "}
                        Order Id : {order?.data?.order?.orderID}
                      </p>
                    </div>
                    <div className="contentBody">
                      <Row>
                        <Col sm="2" className="my-2">
                          <Accordion defaultActiveKey="0">
                            {order?.data?.meals?.length > 0 &&
                              order?.data?.meals?.map((item, index) => (
                                <Accordion.Item
                                  // className={`${styles.accordionItm} ${item?.status == "" } bg-danger bg-success bg-warning `}
                                  className={`${styles.accordionItm} ${
                                    item?.status === "cancelled"
                                      ? "bg-danger"
                                      : item?.status === "confirmed"
                                      ? "bg-success"
                                      : item?.status === "delivered"
                                      ? "bg-primary"
                                      : item?.status === "paused"
                                      ? "bg-secondary"
                                      : item?.status === "onTheWay"
                                      ? "bg-info"
                                      : item?.status === "inTransit"
                                      ? "bg-warning"
                                      : "bg-warning"
                                  }`}
                                  eventKey={index.toString()}
                                  key={item?.week}
                                >
                                  <Accordion.Header
                                    className={`${styles.accordionHeader}`}
                                  >
                                    {/* {`Order ${index + 1}`} */}
                                    {`Delivery date ${
                                      item?.subOrderID || index + 1
                                    }`}
                                  </Accordion.Header>
                                  <Accordion.Body className="px-1 py-0">
                                    <ul className="list-unstyled ps-0 mb-0">
                                      {/* {item?.preparingDates?.length > 0 &&
                                        item?.preparingDates.map(
                                          (date, idx) => ( */}
                                      <li className="py-2">
                                        <div
                                          className={`text-center position-relative p-2 rounded cursor-pointer ${
                                            moment(
                                              selectedDay?.deliveryDate
                                            )?.format("YYYY-MM-DD") ===
                                            moment(item?.deliveryDate)?.format(
                                              "YYYY-MM-DD"
                                            )
                                              ? "bg-[#3E0799] text-white"
                                              : "text-gray-400"
                                          }`}
                                          style={{
                                            background:
                                              moment(
                                                selectedDay?.deliveryDate
                                              )?.format("YYYY-MM-DD") ===
                                              moment(
                                                item?.deliveryDate
                                              )?.format("YYYY-MM-DD")
                                                ? "#3E0799"
                                                : "",
                                          }}
                                          onClick={() => setSelectedDay(item)}
                                        >
                                          <h6 className="m-0 fw-sbold py-1">
                                            {moment(item?.deliveryDate).format(
                                              "dddd"
                                            )}
                                          </h6>
                                          <p className="m-0">
                                            {moment(item?.deliveryDate).format(
                                              "DD/MM"
                                            )}
                                          </p>
                                        </div>
                                      </li>
                                      {/* )
                                        )} */}
                                    </ul>
                                  </Accordion.Body>
                                </Accordion.Item>
                              ))}
                          </Accordion>
                        </Col>
                        <Col sm="10" className="my-2">
                          <Row>
                            <Col lg="12">
                              <div className="d-flex align-items-center justify-content-between  text-end">
                                <div>
                                  Status :{" "}
                                  <span className="text-[#3E0799] fw-bold text-uppercase">
                                    {selectedDay?.status}
                                  </span>
                                </div>
                                <div>
                                  Sub order ID :{" "}
                                  <span className="text-[#3E0799] fw-bold text-uppercase">
                                    {selectedDay?.subOrderID}
                                  </span>
                                </div>
                                {renderButton(selectedDay)}
                              </div>
                            </Col>
                            <Col sm="10" className="my-2">
                              <DatesHeader
                                selectedDate={selectedDate}
                                dates={dates}
                                canSwitchDate={true}
                                setSelectedDate={setSelectedDate}
                                arrowShow={false}
                              />
                            </Col>

                            {/* Products Section */}
                            {selectedMeals?.length > 0 &&
                              selectedMeals[0]?.products?.length > 0 && (
                                <Col lg="12" className="my-3">
                                  <h6 className="m-0 py-2 text-center fw-sbold text-dark">
                                    Products
                                  </h6>
                                  <Row>
                                    {selectedMeals[0]?.products?.map(
                                      (product, index) => {
                                        // Get product details - handle both object and string references
                                        const productDetails =
                                          typeof product.productId === "object"
                                            ? product.productId
                                            : { name: "Product" };
                                        const flavourDetails =
                                          typeof product.flavourId === "object"
                                            ? product.flavourId
                                            : { name: "Flavour" };
                                        const sizeDetails =
                                          typeof product.sizeId === "object"
                                            ? product.sizeId
                                            : { name: "Size" };

                                        return (
                                          <Col sm="4" key={index}>
                                            <div
                                              className={`${styles.cardCstm} cardCstm border rounded`}
                                            >
                                              <div className="imgWrp">
                                                <img
                                                  src={
                                                    flavourDetails
                                                      ?.images?.[0] ||
                                                    productDetails?.image ||
                                                    "https://via.placeholder.com/300x200?text=Product"
                                                  }
                                                  alt=""
                                                  loading="lazy"
                                                  width={1000}
                                                  height={10000}
                                                  decoding="async"
                                                  className="w-full img-fluid object-fit-cover"
                                                  style={{
                                                    height: 150,
                                                    color: "transparent",
                                                    borderTopLeftRadius: 5,
                                                    borderTopRightRadius: 5,
                                                  }}
                                                />
                                              </div>
                                              <div className="contentBody">
                                                <h6 className="m-0 fw-sbold p-2 pb-1">
                                                  {productDetails?.name}
                                                </h6>
                                                <div className="p-2">
                                                  <p className="m-0 text-muted small">
                                                    Flavour:{" "}
                                                    {flavourDetails?.name}
                                                  </p>
                                                  <div className="d-flex align-items-center gap-2 mt-2">
                                                    {sizeDetails
                                                      ?.images?.[0] && (
                                                      <img
                                                        src={
                                                          sizeDetails.images[0]
                                                        }
                                                        alt=""
                                                        style={{
                                                          width: 30,
                                                          height: 30,
                                                          objectFit: "cover",
                                                          borderRadius: 4,
                                                        }}
                                                      />
                                                    )}
                                                    <span className="text-dark fw-medium">
                                                      Size: {sizeDetails?.name}
                                                    </span>
                                                  </div>
                                                </div>
                                                <h6 className="price p-2 text-base text-center fw-sbold">
                                                  {priceCurrency(product.price)}
                                                </h6>
                                                <div className="pt-1 pb-2 btnWrpper px-2">
                                                  <div className="py-1">
                                                    <button
                                                      className={`${styles.submitBtn} d-flex align-items-center fw-bold justify-content-center btn w-100`}
                                                      disabled
                                                    >
                                                      Qty: {product.quantity}
                                                    </button>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </Col>
                                        );
                                      }
                                    )}
                                  </Row>
                                </Col>
                              )}

                            {/* Meals Section - Removed to show only product cards */}
                          </Row>
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              </Col>
              <Col md="6" className="my-2">
                {/* Only show Spicy Level for meal plans (type 3) */}
                {order?.data?.order?.type === 3 && (
                  <div className="cardCstm bg-light rounded-3 p-2 px-3 mb-3">
                    <ul className="list-unstyled pl-0 mb-0">
                      <li className="py-2 border-bottom">
                        <div className="py-1">
                          <h6 className="m-0 fw-sbold text-base pb-1">
                            Spicy Level
                          </h6>
                          {order?.data?.order?.spicyLevel || "No data found!"}
                          <p className="m-0 text-gray-500">{}</p>
                        </div>
                      </li>
                    </ul>
                  </div>
                )}

                <div className="cardCstm bg-light rounded-3 p-2 px-3">
                  <ul className="list-unstyled pl-0 mb-0">
                    <li className="py-2 border-bottom">
                      <div className="py-1">
                        <h6 className="m-0 fw-sbold text-base pb-1">
                          Customer Name
                        </h6>
                        {order?.data?.order?.deliveryAddress?.fullName}
                        <p className="m-0 text-gray-500">{}</p>
                      </div>
                    </li>
                    <li className="py-2 border-bottom">
                      <div className="py-1">
                        <h6 className="m-0 fw-sbold text-base pb-1">
                          Phone Number
                        </h6>
                        {order?.data?.order?.deliveryAddress?.phoneNumber}
                        <p className="m-0 text-gray-500">{}</p>
                      </div>
                    </li>
                    <li className="py-2 border-bottom">
                      <div className="py-1">
                        <h6 className="m-0 fw-sbold text-base pb-1">
                          Delivery Address
                        </h6>
                        <p className="m-0 text-gray-500">
                          {order?.data?.order?.deliveryAddress?.houseNo},{" "}
                          {order?.data?.order?.deliveryAddress?.addressLine1},{" "}
                          {order?.data?.order?.deliveryAddress?.addressLine2},{" "}
                          {order?.data?.order?.deliveryAddress?.emirates},{" "}
                          {order?.data?.order?.deliveryAddress?.country},{" "}
                          {/* {order?.data?.order?.deliveryAddress?.state},{" "} */}
                        </p>

                        {/* <p className="m-0 text-gray-500">
                          <Link to={order?.data?.order?.deliveryAddress?.locationUrl} target="_blank">
                            {order?.data?.order?.deliveryAddress?.location}
                          </Link>
                        </p> */}
                      </div>
                    </li>
                    <li className="py-2 border-bottom">
                      <div className="py-1">
                        <h6 className="m-0 fw-sbold text-base pb-1">
                          Location
                        </h6>
                        <p className="m-0 text-gray-500">
                          <Link
                            to={
                              order?.data?.order?.deliveryAddress?.locationUrl
                            }
                            target="_blank"
                          >
                            {order?.data?.order?.deliveryAddress?.location}
                          </Link>
                        </p>
                      </div>
                    </li>
                  </ul>
                </div>
                <div className="btnWrpper mt-2">
                  <button
                    className={`${styles.borderedBtn} d-flex align-items-center justify-content-center w-100 btn`}
                    type="button"
                    onClick={() => setCancelConfirmation(true)}
                    disabled={
                      isUpdating || order?.data?.order?.status === "cancelled"
                    }
                  >
                    {order?.data?.order?.status === "cancelled" ? (
                      <span className="text-gray-500">Order Cancelled</span>
                    ) : (
                      "Cancel Order"
                    )}
                  </button>
                </div>
              </Col>
              <Col md="6" className="my-2">
                <div className="cardCstm bg-light rounded-3 p-2 px-3">
                  <div className="top pb-2">
                    <h6 className="m-0 fw-sbold text-base pb-1">
                      Order Summary
                    </h6>
                  </div>
                  <ul className="list-unstyled pl-0 mb-0">
                    <li className="py-2 border-bottom">
                      <ul className="list-unstyled pl-0 mb-0">
                        {order?.data?.order?.isLongTermApplied && (
                          <>
                            <li className="py-2 border-bottom">
                              <div className="d-flex align-items-center justify-content-between py-2">
                                <div className="left d-flex align-items-center gap-2">
                                  <span className="icn">
                                    <svg
                                      width="14"
                                      height="14"
                                      viewBox="0 0 14 14"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <g clip-path="url(#clip0_1_22289)">
                                        <rect
                                          width="14"
                                          height="14"
                                          rx="7"
                                          fill="#32936F"
                                          fill-opacity="0.24"
                                        ></rect>
                                        <path
                                          d="M9.86256 5.11575C9.82287 5.07908 9.77565 5.04996 9.72362 5.0301C9.6716 5.01023 9.6158 5 9.55944 5C9.50308 5 9.44728 5.01023 9.39525 5.0301C9.34323 5.04996 9.29601 5.07908 9.25632 5.11575L6.0757 8.03506L4.73941 6.80629C4.6982 6.76981 4.64956 6.74112 4.59625 6.72186C4.54295 6.70261 4.48603 6.69316 4.42874 6.69407C4.37146 6.69498 4.31493 6.70622 4.26238 6.72716C4.20983 6.74809 4.1623 6.7783 4.1225 6.81608C4.08269 6.85385 4.05139 6.89844 4.03038 6.9473C4.00938 6.99615 3.99907 7.04833 4.00007 7.10084C4.00106 7.15335 4.01332 7.20516 4.03616 7.25332C4.059 7.30149 4.09196 7.34506 4.13317 7.38155L5.77258 8.88425C5.81227 8.92092 5.85948 8.95004 5.91151 8.9699C5.96353 8.98977 6.01934 9 6.0757 9C6.13206 9 6.18786 8.98977 6.23988 8.9699C6.29191 8.95004 6.33913 8.92092 6.37882 8.88425L9.86256 5.69101C9.90589 5.65436 9.94048 5.60989 9.96413 5.56038C9.98779 5.51088 10 5.45742 10 5.40338C10 5.34934 9.98779 5.29588 9.96413 5.24638C9.94048 5.19687 9.90589 5.1524 9.86256 5.11575Z"
                                          fill="#32936F"
                                        ></path>
                                      </g>
                                      <defs>
                                        <clipPath id="clip0_1_22289">
                                          <rect
                                            width="14"
                                            height="14"
                                            rx="7"
                                            fill="white"
                                          ></rect>
                                        </clipPath>
                                      </defs>
                                    </svg>
                                  </span>
                                  <p className="m-0 text-dark fw-normal">
                                    {
                                      order?.data?.order?.planDurationDetails
                                        ?.label
                                    }{" "}
                                    <span className="text-muted">applied</span>
                                  </p>
                                </div>
                                <div className="right">
                                  <p className="m-0 text-muted small fw-light">
                                    -
                                    {priceCurrency(
                                      order?.data?.order?.longTermDiscountValue
                                    )}
                                    {/* calculate percentage and show  */}(
                                    {`${order?.data?.order?.planDurationDetails?.discount}%`}
                                    )
                                  </p>
                                </div>
                              </div>
                            </li>
                            <li className="py-2 d-flex align-items-center justify-content-between">
                              <p className="m-0 fw-normal text-dark text-base">
                                Discounted Price
                              </p>
                              <p className="m-0 fw-normal text-dark text-base">
                                {priceCurrency(
                                  order?.data?.order?.longTermDiscount
                                )}
                              </p>
                            </li>
                          </>
                        )}
                        {order?.data?.order?.isPromo && (
                          <>
                            <li className="py-2 border-bottom">
                              <div className="d-flex align-items-center justify-content-between py-2">
                                <div className="left d-flex align-items-center gap-2">
                                  <span className="icn">
                                    <svg
                                      width="14"
                                      height="14"
                                      viewBox="0 0 14 14"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <g clip-path="url(#clip0_1_22289)">
                                        <rect
                                          width="14"
                                          height="14"
                                          rx="7"
                                          fill="#32936F"
                                          fill-opacity="0.24"
                                        ></rect>
                                        <path
                                          d="M9.86256 5.11575C9.82287 5.07908 9.77565 5.04996 9.72362 5.0301C9.6716 5.01023 9.6158 5 9.55944 5C9.50308 5 9.44728 5.01023 9.39525 5.0301C9.34323 5.04996 9.29601 5.07908 9.25632 5.11575L6.0757 8.03506L4.73941 6.80629C4.6982 6.76981 4.64956 6.74112 4.59625 6.72186C4.54295 6.70261 4.48603 6.69316 4.42874 6.69407C4.37146 6.69498 4.31493 6.70622 4.26238 6.72716C4.20983 6.74809 4.1623 6.7783 4.1225 6.81608C4.08269 6.85385 4.05139 6.89844 4.03038 6.9473C4.00938 6.99615 3.99907 7.04833 4.00007 7.10084C4.00106 7.15335 4.01332 7.20516 4.03616 7.25332C4.059 7.30149 4.09196 7.34506 4.13317 7.38155L5.77258 8.88425C5.81227 8.92092 5.85948 8.95004 5.91151 8.9699C5.96353 8.98977 6.01934 9 6.0757 9C6.13206 9 6.18786 8.98977 6.23988 8.9699C6.29191 8.95004 6.33913 8.92092 6.37882 8.88425L9.86256 5.69101C9.90589 5.65436 9.94048 5.60989 9.96413 5.56038C9.98779 5.51088 10 5.45742 10 5.40338C10 5.34934 9.98779 5.29588 9.96413 5.24638C9.94048 5.19687 9.90589 5.1524 9.86256 5.11575Z"
                                          fill="#32936F"
                                        ></path>
                                      </g>
                                      <defs>
                                        <clipPath id="clip0_1_22289">
                                          <rect
                                            width="14"
                                            height="14"
                                            rx="7"
                                            fill="white"
                                          ></rect>
                                        </clipPath>
                                      </defs>
                                    </svg>
                                  </span>
                                  <p className="m-0 text-dark fw-normal">
                                    {order?.data?.order?.couponDetail?.code}{" "}
                                    <span className="text-muted">applied</span>
                                  </p>
                                </div>
                                <div className="right">
                                  <p className="m-0 text-muted small fw-light">
                                    -
                                    {priceCurrency(
                                      order?.data?.order?.discountPrice
                                    )}{" "}
                                    (
                                    {/* {order?.data?.order?.couponDetail
                                      ?.discountType === "Percent"
                                      ? `${order?.data?.order?.couponDetail?.discountValue}%`
                                      : `AED ${order?.data?.order?.couponDetail?.discountValue}`} */}
                                    {/* {order?.data?.order?.couponDetail && (
                                      `${order?.data?.order?.couponDetail.promoCodeType === "userReferral"
                                        ? order.data.order.couponDetail.referralDiscountForReferrer
                                        : order.data.order.couponDetail.discountValue
                                      } ${order.data.order.couponDetail.discountType === "Percent" ? "%" : "AED"}`
                                    )} */}
                                    {order?.data?.order?.couponDetail &&
                                      `${
                                        order?.data?.order?.couponDetail
                                          .promoCodeType === "userReferral" &&
                                        order?.data?.order?.userId ===
                                          order?.data?.order?.couponDetail
                                            ?.addedBy
                                          ? order.data.order.couponDetail
                                              .referralDiscountForReferrer
                                          : order.data.order.couponDetail
                                              .discountValue
                                      } ${
                                        order.data.order.couponDetail
                                          .discountType === "Percent"
                                          ? "%"
                                          : "AED"
                                      }`}
                                    )
                                  </p>
                                </div>
                              </div>
                            </li>
                            
                          </>
                        )}
                        {order?.data?.order?.isAdvanceMacro && (
                          <li className="py-2 d-flex align-items-center justify-content-between">
                            <p className="m-0 fw-normal text-dark text-base">
                              Advanced Macro Fee
                            </p>
                            <p className="m-0 fw-normal text-dark text-base">
                              {priceCurrency(
                                order?.data?.order?.advanceMacroFees
                              )}
                            </p>
                          </li>
                        )}
                        <li className="py-2 d-flex align-items-center justify-content-between">
                          <p className="m-0 fw-normal text-dark text-base">
                            Delivery Fee
                          </p>
                          <p className="m-0 fw-normal text-dark text-base">
                            {priceCurrency(order?.data?.order?.deliveryFees)}
                          </p>
                        </li>
                        
                        {order?.data?.order?.isSwaped && (
                          <li className="py-2 d-flex align-items-center justify-content-between">
                            <p className="m-0 font-normal text-dark text-base">
                              Swapped Amount
                            </p>
                            <p className="m-0 font-normal text-dark text-base">
                              {/* {/ ${data?.order?.boxPrice} /} */}
                              {priceCurrency(order?.data?.order?.swapedAmount)}
                            </p>
                          </li>
                        )}
                      </ul>
                    </li>
                    <li className="py-2 border-bottom">
                      <div
                        className=" py-2 px-3 d-flex align-items-center justify-content-between"
                        style={{ background: "rgb(241, 241, 234)" }}
                      >
                        <p className="m-0 fw-sbold text-dark">Total Payment</p>
                        <p className="m-0 fw-sbold text-dark">
                          {" "}
                          {priceCurrency(order?.data?.order?.payAmount)}
                        </p>
                      </div>
                    </li>
                  </ul>
                </div>
              </Col>
            </Row>
          )}
        </Container>
      </section>
    </>
  );
};

export default StoreOrderDetailToday;
